var render = function render(){var _vm=this,_c=_vm._self._c;return _c('worker',{attrs:{"title":"在职员工信息管理","fun-auth-other":_vm.funAuth,"isDiscipline":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }